import { takeLatest, put, call, select } from 'redux-saga/effects';
import { UPDATE_DEPOSIT_SAGA } from "../sagaTypes";
import { loaderAction, setDepositFormAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { DEPOSIT_FORM_INITIAL } from "../initialStateConstant";
import { getDepositListSagaAction, getUserInfoSagaAction } from "../sagaActions";

const request = data => {
    return fetch(`${ url }/update_deposit`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerUpdateDeposit(args) {
    const user = yield select(state => state.user);
    const currentUser = yield select(state => state.currentUser);
    const currentEstablishment = yield select(state => state.currentEstablishment);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('id', args.data.id);
        formData.append('sum', args.data.sum);
        formData.append('user', currentUser.id);
        formData.append('payment', args.data.payment);
        formData.append('discount', args.data.discount);
        formData.append('establishment', currentEstablishment);


        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Закрываем форму депозита
            yield put(setDepositFormAction(DEPOSIT_FORM_INITIAL));
            // Запрашиваем новые данные
            yield put(getDepositListSagaAction({ user: currentUser.id }));
            // Обновляем данные пользователя, для обновления размера депозита
            yield put(getUserInfoSagaAction({ id: currentUser.id }));
            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherUpdateDeposit() {
    yield takeLatest(UPDATE_DEPOSIT_SAGA, workerUpdateDeposit);
}